<div class="unauthorized-container">
    <div class="row detail-container">
      <div class="col-12">
        <div class="card p-4">
          <div class="row justify-content-center">
            <h1>Unauthorized</h1>
          </div>
          <div class="row justify-content-center">
            <h1>You don't have access to this portal <a class="sineout" (click)="doLogout(PROFILE)">Click here to signout</a></h1>
          </div>
        </div>
      </div>
    </div>
  </div>
